import React from 'react';
import { animated, useSpring } from 'react-spring';

interface Props {
  rotation?: number;
  scale?: number;
  x?: number;
  y?: number;
  timing?: number;
  children: React.ReactNode;
}

function Boop({
  rotation = 0,
  scale = 1,
  x = 0,
  y = 0,
  timing = 150,
  children,
}: Props) {
  const [isBooped, setIsBooped] = React.useState(false);

  const style = useSpring({
    transform: isBooped
      ? `translate(${x}px, ${y}px)
         rotate(${rotation}deg)
         scale(${scale})`
      : `translate(0px, 0px)
         rotate(0deg)
         scale(1)`,
    config: {
      tension: 300,
      friction: 10,
    },
  });

  React.useEffect(() => {
    if (!isBooped) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsBooped(false);
    }, timing);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isBooped, timing]);

  const trigger = () => {
    setIsBooped(true);
  };

  return (
    <animated.span
      onMouseEnter={trigger}
      onClick={trigger}
      style={{
        ...style,
        display: 'inline-block',
        backfaceVisibility: 'hidden',
      }}
    >
      {children}
    </animated.span>
  );
}

export default Boop;
